module.exports = __webpack_public_path__ + "static/img/640.8bd133a.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/640.gif
// module id = afbR
// module chunks = 0